const n="none",e="blend";export{e as SCALEMODE_BLEND,n as SCALEMODE_NONE};
